'use client';

import dynamic from 'next/dynamic';
import type { ComponentProps } from 'react';
import AdPlacement from './AdPlacement';

const DynamicAdPlacement = dynamic(() => import('./AdPlacement'), { ssr: false });

export default function AdPlacementServer(props: ComponentProps<typeof AdPlacement>) {
  return <DynamicAdPlacement {...props} />;
}
